//const Serverurl= ["http://localhost:5000/"]

const Serverurl= ["https://backend.prep4sale.com.au/"]

export default Serverurl;